export enum DestinationMenuItem {
    EDIT,
    DELETE,
    CONVERT,
}